module.exports = __webpack_public_path__ + "img/Ireland.cc033cc1.png";